/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Value_Prep_DescInputs */



/**
* | output |
* | --- |
* | "A tailored prep for every conversation: what came up last time, what's still open, and what to pay attention to this time, built on proven templates, or one ..." |
*
* @param {Onboarding_Value_Prep_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_value_prep_desc = /** @type {((inputs?: Onboarding_Value_Prep_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Value_Prep_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voor elk gesprek een voorbereiding op maat: wat er vorige keer besproken is, wat er nog openstaat en waar je dit keer op wil letten. Opgebouwd volgens geijkte templates, of een template die je zelf maakt.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pour chaque conversation, une préparation sur mesure : ce qui a été dit la dernière fois, ce qui reste ouvert et ce à quoi vous voulez faire attention cette fois-ci. Construite selon des modèles éprouvés, ou selon un modèle que vous créez vous-même.")
	return /** @type {LocalizedString} */ ("A tailored prep for every conversation: what came up last time, what's still open, and what to pay attention to this time, built on proven templates, or one you create yourself.")
});